module.exports = __webpack_public_path__ + "img/ghost.ff397345.svg";